@use '../../styling/colors.scss' as *;

.RemoveButton {
  background: transparent;
  border: none;
  outline: none;
  display: flex;
  padding: 2px;
  cursor: pointer;

  path {
    fill: $color-grey-C;
  }

  &:hover,
  &:focus {
    path {
      fill: $color-grey-B;
    }
  }

  .IconStyle {
    stroke: $theme-color-tab-label-unselected;
  }
}
